export default __webpack_public_path__ + "static/media/lysningen-property-08.10713297.jpg";